<div [formGroup]="element.group" [ngClass]="element?.theme?.outerWrap" class="form-group">
  <label [attr.for]="element.elementOptions.id" [ngClass]="element?.theme?.labelClass">
    {{ element.elementOptions.label | translate }}
    @if (element.validations?.required) {
      <b style="color:red">*</b>
    }
    @if (element?.tooltip?.display) {
      <span>
        <i class="fa fa-question-circle" aria-hidden="true" placement="right" ngbTooltip="{{element.tooltip.text || 'right'}}"></i>
      </span>
      } :
    </label>
    <textarea [attr.id]="element.id" class="form-control" [formControlName]="element.name" [ngClass]="element?.theme?.control"
      [attr.rows]="element.elementOptions.rows" [attr.cols]="element.elementOptions.cols" [attr.placeholder]="element.elementOptions.placeholder"
    [value]="element.elementOptions.value"></textarea>

    @if (element.group.controls[this.element['name']].dirty && !element.group.controls[this.element['name']].pristine && (element.group.controls[this.element['name']].status === 'INVALID')) {
      <div class="alert alert-danger" role="alert">
        <rs-error-message [fieldForm]="element.group.controls[this.element['name']]" [field]="element"></rs-error-message>
      </div>
    }
  </div>
